import { getAPIFullUrl, getAxiosConfig, handleApiError } from './risapi';
import { risapi } from './risapi';

export const getCreditNotes = async (filterParameters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/credit-notes', filterParameters), getAxiosConfig());
        if (response.status === 200) callback(response.data);
    } catch (error) { handleApiError(error); callback({ error }); }
};

export const fetchCreditNote = async (id, callback) => {
    try {
        const response = await risapi.get(`/api/credit-notes/${id}`, getAxiosConfig());
        if (response.status === 200) callback(response.data);
    } catch (error) { handleApiError(error); callback({ error }); }
};

export const createCreditNote = async (newData, callback) => {
    try {
        const response = await risapi.post('/api/credit-notes', newData, getAxiosConfig());
        if (response.status === 201) callback(response.data);
    } catch (error) { callback({ error }); }
};

export const updateCreditNote = async (id, updateData, callback) => {
    try {
        const response = await risapi.put(`/api/credit-notes/${id}`, updateData, getAxiosConfig());
        if (response.status === 200) callback(response.data);
    } catch (error) { callback({ error }); }
};

export const destroyCreditNote = async (id, callback) => {
    try {
        const response = await risapi.delete(`/api/credit-notes/${id}`, getAxiosConfig());
        if (response.status === 204) callback({ success: true });
    } catch (error) { callback({ error }); }
};